// TODO: add our encryption here in the same way as it is implemented in the `lib/api.js`.

import axios from "axios";
import { getHttpApiAddress } from "../../actions";
import { urlConfig } from "../../lib/utils";

const getBaseIAapiUrl = () => {
  return `${getHttpApiAddress()}/api/ia`;
};

export const requestGreeting = async (providerID) => {
  // TODO: how do I mock this properly for the tests when it runs in a separate process? Using env files?
  if (urlConfig.staticConfig) {
    return [
      {
        type: "text",
        data: "Hi, welcome to Testing Community!",
      },
    ];
  }

  const url = `${getBaseIAapiUrl()}/greeting/${providerID}`;
  const { data } = await axios.get(url);
  return data;
};

export const postQuestion = async (requestBody) => {
  const url = `${getBaseIAapiUrl()}/ask`;
  const { data } = await axios.put(url, requestBody);
  return data;
};

export const postUserAction = (data, provider_profile) => {
  const url = `${getBaseIAapiUrl()}/user-actions`;
  axios.post(url, {
    ...data,
    provider_profile,
  });
};
